<template>
  <div>
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnListDefault"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        rowKey="contractNo"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :title="item.title"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ formatColumn(scope.row[item.field]) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import tableMixins from '@/common/mixins/table.js';
  import { getUserCompanyList } from '@/common/js/util';
  import COM_API from '@/api/masterData/company.js';
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/salsManage/salesLadingbill.js';
  import moment from 'moment';
  export default {
    name: 'list',
    mixins: [tableMixins],
    data() {
      return {
        footerTotalCols: {
          amount: [
            'ladingQuantity',
            'amountIncludingTax',
            'amountExcludingTax',
            'invoiceAmountExcludingTax',
            'costExcludingTax',
            'grossProfitExcludingTax',
          ],
          quantity: ['pickingQuantity', 'actualSendQuantity'],
        },
        query: {
          ladingBusinessCompanyCodeIn: null,
          ladingBusinessDepartmentNoIn: null,
          ladingCreateDateStart: null,
          ladingCreateDateEnd: null,
          ladingNo: null,
          customerNoIn: null,
          storageNoIn: null,
          productNoIn: null,
          contractNo: null,
          businessInboundBatchNo: null,
          purchaseContractNoIn: null,
          goldenTaxDateStart: null,
          goldenTaxDateEnd: null,
          ladingStatusIn: null,
          issueStatus: null,
        },
        ladingStatusOptions: [],
        columnListDefault: [
          // {
          //   type: "checkbox",
          //   visible: true,
          //   width: "50",
          //   fixed: "left"
          // },
          {
            field: 'storageNo',
            title: '仓库编码',
            visible: true,
          },
          {
            field: 'purchaseContractNo',
            title: '采购合同号',
            visible: true,
          },
          {
            field: 'customerName',
            title: '客户名称',
            visible: true,
          },
          //业务性质
          {
            field: 'contractNo',
            title: '销售合同号',
            visible: true,
          },
          {
            field: 'ladingCreateDate',
            title: '开单日期',
            visible: true,
            format: 'time',
          },
          {
            field: 'ladingNo',
            title: '销售提单号',
            visible: true,
            width: '180',
          },
          {
            field: 'productDesc',
            title: '商品描述',
            visible: true,
          },
          {
            field: 'ladingQuantity',
            title: '提单数量',
            visible: true,
          },
          {
            field: 'businessChangingUnitPrice',
            title: '含税发货单价（本币）',
            visible: true,
          },
          {
            field: 'costUnitPriceExcludingTax',
            title: '不含税成本价（本币）',
            visible: true,
            sortable: true,
          },
          {
            field: 'storageName',
            title: '仓库名称',
            visible: true,
          },
          {
            field: 'ladingSalesmanName',
            title: '销售业务员',
            visible: true,
          },
          {
            field: 'businessInboundBatchNo',
            title: '批次号',
            visible: true,
          },
          {
            field: 'externalContractNo',
            title: '销售外部合同号',
            visible: true,
          },
          {
            field: 'pickingQuantity',
            title: '提单拣配数量',
            visible: true,
          },
          {
            field: 'actualSendQuantity',
            title: '仓库实发数量',
            visible: true,
          },
          {
            field: 'amountIncludingTax',
            title: '含税金额 （本币）',
            visible: true,
          },
          {
            field: 'amountExcludingTax',
            title: '不含税金额(本币)',
            visible: true,
          },
          {
            field: 'invoiceAmountExcludingTax',
            title: '不含税开票金额',
            visible: true,
          },
          {
            field: 'costExcludingTax',
            title: '不含税成本（本币）',
            visible: true,
          },
          {
            field: 'grossProfitExcludingTax',
            title: '不含税毛利（本币）',
            visible: true,
          },
          {
            field: 'supplierName',
            title: '供应商',
            visible: true,
          },
          {
            field: 'goldenTaxDate',
            title: '销售开票日期',
            visible: true,
          },
          {
            field: 'invoiceQuantity',
            title: '销售开票数量',
            visible: true,
          },
          {
            field: 'accountedDate',
            title: '过账日期',
            visible: true,
          },
          {
            field: 'ladingBusinessDepartmentName',
            title: '部门名称',
            visible: true,
          },
          {
            field: 'deliveryMethod',
            title: '交货方式',
            visible: true,
          },
          {
            field: 'tradeType',
            title: '贸易类型',
            visible: true,
          },
          {
            field: 'contractSalesmanName',
            title: '采购业务员',
            visible: true,
          },
          {
            field: 'mark',
            title: '提单备注',
            visible: true,
          },
          {
            field: 'ladingStatus',
            title: '提单状态',
            visible: true,
          },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        lang: (state) => state.lang.language,
        dict: (state) => state.dict,
      }),
      searchColumns() {
        return [
          {
            type: 'selectMultiple', // 公司：操作人账户下公司
            name: this.$t('contractAgency.company'),
            prop: 'ladingBusinessCompanyCodeIn',
            options: getUserCompanyList(),
          },
          {
            prop: 'ladingBusinessDepartmentNoIn',
            name: this.$t('salePurchase.search.contractBusinessDepartment'),
            type: 'treeSelect',
            apiUrl: COM_API.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            multiple: true,
            clearable: false,
          },
          {
            prop: 'ladingCreateDateStart',
            name: this.$t('salesBill.search.startLadingCreateDate'),
            type: 'startDaterangePicker',
          },
          {
            prop: 'ladingCreateDateEnd',
            name: this.$t('salesBill.search.endLadingCreateDate'),
            type: 'endDaterangePicker',
          },
          {
            prop: 'ladingNo',
            name: this.$t('payablesBillList.search.salesLadingNo'),
            type: 'input',
            searchType: 'salesLading',
            isMultiple: true,
            placeholder: this.$t('payablesBillList.search.saleNoPlaceholder'),
          },
          {
            prop: 'customerNoIn',
            type: 'searchTableSpec',
            name: this.$t('salePurchase.search.customer'),
            searchType: 'supplier',
            extraData: {
              partnerTypes: 'HZHB03,HZHB01',
              departmentCode: this.query.ladingBusinessDepartmentNoIn,
              companyCode: this.query.ladingBusinessCompanyCodeIn
                ? this.query.ladingBusinessCompanyCodeIn.join()
                : '', //公司
            },
            isNeedMultipleValue: true,
          },
          //仓库
          {
            prop: 'storageNoIn',
            type: 'searchTableSpec',
            name: this.$t('withholdingList.column.storageName'),
            placeholder: this.$t('withholdingList.placeholder.storageNamePlaceholder'),
            searchType: 'warehouse',
            isMultiple: false,
          },
          {
            prop: 'productNoIn',
            type: 'searchTableSpec',
            name: this.$t('salePurchase.search.product'),
            searchType: 'goodsDetail',
            isNeedMultipleValue: true,
          },
          {
            prop: 'contractNo',
            name: this.$t('payablesBillList.search.salesContractNo'),
            type: 'input',
            searchType: 'contract',
            isMultiple: true,
            extraData: { contractCategory: 'sales', contractStatus: 'ZT03' },
            placeholder: this.$t('payablesBillList.search.salesContractPlaceholder'),
          },
          {
            prop: 'businessInboundBatchNo',
            name: '批次号',
            type: 'input',
            maxlength: 30,
            placeholder: '请输入批次号',
          },
          {
            type: 'startDaterangePicker',
            prop: 'goldenTaxDateStart',
            name: this.$t('saleInvoice.goldenTaxDateStart'),
          },
          {
            type: 'endDaterangePicker',
            prop: 'goldenTaxDateEnd',
            name: this.$t('saleInvoice.goldenTaxDateEnd'),
          },
          {
            type: 'select',
            prop: 'issueStatus',
            name: '销售开票',
            options: [
              { label: '已开票', value: '3' },
              { label: '未开票', value: '1' },
            ],
          },
          {
            prop: 'purchaseContractNoIn',
            name: this.$t('payablesBillList.search.purchaseContractNo'),
            type: 'input',
            searchType: 'contract',
            isMultiple: true,
            extraData: { contractCategory: 'purchase', contractStatus: 'ZT03' },
            placeholder: this.$t('payablesBillList.search.procurementContractPlaceholder'),
          },
          {
            prop: 'ladingStatusIn',
            name: this.$t('salesBill.search.ladingStatus'),
            type: 'selectMultiple',
            placeholder: this.$t('salePurchase.search.contractStatusPlaceholder'),
            options: this.ladingStatusOptions,
          },
        ];
      },
    },
    mounted() {
      const tenantCode = this.userInfo.userInfo.tenantCode;
      this.$axios
        .post(API.DICT_LIST, { dictType: 'sales_lading_status', tenantCode })
        .then((res) => {
          if (res.data.code === 0) {
            this.ladingStatusOptions = res.data.data;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      this.getData();
    },
    methods: {
      getData() {
        this.load = true;
        let params = {
          pageSize: this.$refs.siruiTable.page.pageSize,
          pageNum: this.$refs.siruiTable.page.pageNum,
          ...this.query,
        };
        if (this.query.ladingBusinessDepartmentNoIn) {
          params.ladingBusinessDepartmentNoIn = this.query.ladingBusinessDepartmentNoIn.split(',');
        }
        if (this.query.customerNoIn) {
          params.customerNoIn = this.query.customerNoIn.map((item) => {
            return item.partnerCode;
          });
        }
        if (this.query.storageNoIn) {
          params.storageNoIn = this.query.storageNoIn.map((item) => {
            return item.storageCode;
          });
        }
        if (this.query.productNoIn) {
          params.productNoIn = this.query.productNoIn.map((item) => {
            return item.productDetailCode;
          });
        }
        this.$axios.post('/warehouse/storageLade/reportStorageLadePage', params).then((res) => {
          this.load = false;
          this.tableData = res.data.data.list;
          if (this.$refs.siruiTable) {
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        });
      },
      resetBtnClick() {
        delete this.query.pageSize;
        delete this.query.pageNum;

        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        this.tableData = [];
        this.$refs.siruiTable.reloadTable(this.tableData);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      formatColumn(row) {
        return moment(row).format('YYYY-MM-DD');
      },
    },
  };
</script>

<style scoped></style>
